import React from "react";
import { Box, Typography } from "@mui/material";

const MenuHandle = ({
  title,
  anchor,
  open,
  toggleOpen,
  isOtherMenuOpen,
  topPosition,
  backgroundColor,
  height,
  maxHeight,
  handleRef,
}) => {
  return (
    <Box
      onClick={toggleOpen}
      sx={{
        position: "fixed",
        top: topPosition || "2%",
        zIndex: (theme) => theme.zIndex.modal + (title === "flights" ? 2 : 1),
        [anchor]: 0,
        width: 22,
        height: height || "25vh",
        maxHeight: maxHeight || "11rem",
        bgcolor: backgroundColor || "#003D50",
        color: "#fff",
        borderTopRightRadius: anchor === "left" ? "20px" : 0,
        borderBottomRightRadius: anchor === "left" ? "20px" : 0,
        borderTopLeftRadius: anchor === "right" ? "20px" : 0,
        borderBottomLeftRadius: anchor === "right" ? "20px" : 0,
        display: "flex",
        ...(isOtherMenuOpen && !open ? { display: "none" } : {}),
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        transform:
          anchor === "left"
            ? open
              ? "translateX(280px)"
              : "translateX(0)"
            : open
            ? "translateX(-280px)"
            : "translateX(0)",
        transition: "transform 150ms ease-in-out",
      }}
      role="button"
      aria-label={`${title || ""} menu`}
      tabIndex={0}
      ref={handleRef}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleOpen();
        }
      }}
    >
      <Typography
        sx={{
          transform: "rotate(270deg)",
          fontSize: 14,
          fontWeight: "bold",
          textTransform: "uppercase",
          color: "#fff",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default MenuHandle;
export { MenuHandle };
